export const getVendorMasterList = state => {
    return state.list
}

export const getVendorMasterDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/vendorMaster/getters.js